import iconLogout from '../../../../assets/img/icon-logout.png';
import iconPayouts from '../../../../assets/img/icon-payouts.png';
import iconPersonalDetails from '../../../../assets/img/icon-personal-details.png';
import iconLock from '../../../../assets/img/icon-security.png';
import LinearSwitchIcon from '../../../../assets/img/switch.png';

export const icons = (hasPaidAndDemoPlan: boolean, hasPayouts: boolean) => {
  const items = [ iconPersonalDetails, ...(hasPayouts ? [iconPayouts] : []), iconLock, iconLogout ];

  return hasPaidAndDemoPlan ? [ LinearSwitchIcon, ...items ] : items;
};
